<template>

  <transition enter-active-class='animated animated3 fadeIn' leave-active-class='animated animated3 fadeOut'>
    <div v-if="visible" class='layerdownload' @click.self='remove'>
        <div v-if="type=='download' && !isLoading" class='download'>
          <div class='top'>
            <div class='lef'>
              <img src="/static/img/index.png">
              <span>移动APP</span>
            </div>
            <div class='cent'></div>
            <div class='righ'>
              <img src="/static/img/index2.png">
              <span>微信公众号</span>
            </div>
          </div>
          <div class='footer'>
            下载/关注，接收最新优惠与活动
          </div>
        </div>
        <div v-if="type=='yinshua' && !isLoading" class='yinshua'>
          <div class='top'>
            <div class='lef'>
              <img src="/static/img/index.png">
              <span>移动APP</span>
            </div>
            <div class='cent'></div>
            <div class='righ'>
              <img src="/static/img/index2.png">
              <span>微信公众号</span>
            </div>
          </div>
          <div class='footer'>
            建议在移动APP上下单并支付
          </div>
        </div>
        <div v-if="type=='make' && !isLoading" class='make'>
          <div class='top'>
            <div class='lef'>
              <img src="/static/img/index.png">
              <span>移动APP</span>
            </div>
            <div class='cent'></div>
            <div class='righ'>
              <img src="/static/img/index2.png">
              <span>微信公众号</span>
            </div>
          </div>
          <div class='footer'>
            请在电脑端 / APP端进行设计
          </div>
        </div>
        <div v-if="type=='itemdetail' && !isLoading" class='itemdetail'>
          <div class='imgs'>
            <swiper class='aa' ref="mySwiper" :options="swiperOption">
                <swiper-slide class="swiper-slide" v-for="(path,index) in ob.showImages" :key="index">
                  <img :src="path"/>
                </swiper-slide>
             <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <i @click.self='remove' class='iconfont icon-guanbi huanchong'></i>
          </div>
          <div class='box'>
            <h3>{{ob.name}}</h3>
            <div class='comment leabel'>
              <span v-for='label in ob.labelArr' :key='label.id'>{{label}}</span>
            </div>
            <div class='description lis'>
              <div class='row'>
                <div class='col-xs-6' v-for='(str,index) in ob.showMessage' :key='index'>
                  <img src="/static/img/dui.png" alt=""><div>{{str}}</div>
                </div>
              </div>
            </div>
            <a target="_blank" :href="'/centre/makedesign/'+ob.str" class="btn huanchong btn-default btn-md btn-block bool hidden-xs">创建设计</a>
            <a target="_blank" class="btn huanchong btn-default btn-md btn-block bool hidden-lg hidden-md hidden-sm">请在电脑/APP端创建</a>
          </div>
        </div>
        <div v-if='isLoading' class='loading'>
          <div class="loader-inner ball-pulse-sync">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
    </div>
  </transition>

</template>

<script>
  import {Swiper,SwiperSlide,directive} from 'vue-awesome-swiper';
  import 'swiper/swiper-bundle.css';
  import Swipers, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
  Swipers.use([Navigation, Pagination, EffectFade, Autoplay])
  import resultcommons from '@/util/resultcommons.js';
  export default {
    name:'Layerdownload',
    props:{
      type:{
        type: String,
        default: 'download'
      },
      data:{
        type: Number
      }
    },
    data(){
      return {
        visible:false,//是否隐藏
        isLoading:false,//是否请求中
        ob:{},
        btnLoading:false,
        swiperOption:{
          slidesPerView: 'auto',
          speed:300,
          centeredSlides:true,
              spaceBetween: 10,
              loop:true,
              autoplay: {
                  delay: 2000,
                  disableOnInteraction:false
                },
                pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable:true,
              clickableClass:'active'
          }
        }
      }
    },
    components: {
        Swiper:Swiper,
        SwiperSlide:SwiperSlide
    },
    methods:{
      remove(){
        if(!this.isLoading){
          this.visible = false;
        }
      },
      requestFun(){
        var that = this;
        if(this.type=='itemdetail'){
          this.isLoading = true;
          resultcommons.apiThemedetail(this,{id:this.data}).then(ob=>{
            this.isLoading = false;
            that.themeFun(ob);
          });
        }else{
        }
      },
      themeFun(ob){
        if(ob.state){
          this.ob = ob.data;
          this.ob.isLoading = false;
        }else{
          this.$message.showMsgBox({
              type: 'warning',
              content: '网络错误'
          });
          this.remove();//关闭
        }
      }
    },
    watch: {
      //监听是否出现滚动
      visible (val) {
          if (val) {
            document.body.style.overflow = 'hidden'
            document.addEventListener('touchmove', ()=>{
            }, {passive: false}) // 禁止页面滑动
        } else {
            document.body.style.overflow = '' // 出现滚动条
            document.removeEventListener('touchmove', ()=>{
            }, {passive: false})
        }
      },
      data: { 
        handler(newVal,oldVal){
          if(newVal!==undefined){
            this.requestFun();
          }
          // this.selectItemsDate = newVal; 
          // if(newVal) {//如果数据变化则重新创建数据用于渲染 
          // this.itemsCreat();//处理数据 
          // } 
        }, 
        immediate:false,//immediate:true代表如果在 wacth 里声明了之后，就会立即先去执行里面的                    
        // handler方法，如果为 false，不会在绑定的时候就执行。 
        deep:true//deep，默认值是 false，代表是否深度监听。 
      } 
    }
  }

</script>


<style scoped lang='less'>
    


  .layerdownload{
    height:100%;
    position:absolute;
    top:0px;
    right:0px;
    bottom:0px;
    left:0px;
    z-index:2;
    background-color:rgba(0,0,0,0.6);
    overflow-y: auto;
  }
  .download{
      width:350px;
      margin:auto;
      background:#FFF;
      border-radius:3px;
      margin-top:5%;
      overflow: hidden;
      margin-bottom:40px;
      .top{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: 20px;
        padding-bottom:10px;
        text-align: center;
        justify-content: center;
        img{
          height:130px;
          display: block;
        }
        .cent{
          width:130px;
          text-align: center;
          &:after{
            content:'';
            display: inline-block;
            width:1px;
            height:100%;
            background:#e6e6e6;;
          }
        }
        span{
          display: inline-block;
          margin-top:10px;
        }
      }
      .footer{
        background:#F3F4F9;
        padding:8px;
        text-align: center;
        color:#666;
        font-size:12px;
        letter-spacing: 1px;
      }
  }
  .yinshua{
    width:350px;
    margin:auto;
    background:#FFF;
    border-radius:3px;
    margin-top:5%;
    overflow: hidden;
    margin-bottom:40px;
    .top{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      padding: 20px;
      padding-bottom:10px;
      text-align: center;
      justify-content: center;
      img{
        height:130px;
        display: block;
      }
      .cent{
        width:130px;
        text-align: center;
        &:after{
          content:'';
          display: inline-block;
          width:1px;
          height:100%;
          background:#e6e6e6;;
        }
      }
      span{
        display: inline-block;
        margin-top:10px;
      }
    }
    .footer{
      background:#F3F4F9;
      padding:8px;
      text-align: center;
      color:#666;
      font-size:12px;
      letter-spacing: 1px;
    }
  }
  .make{
    width:350px;
    margin:auto;
    background:#FFF;
    border-radius:3px;
    margin-top:5%;
    overflow: hidden;
    margin-bottom:40px;
    .top{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      padding: 20px;
      padding-bottom:10px;
      text-align: center;
      justify-content: center;
      img{
        height:130px;
        display: block;
      }
      .cent{
        width:130px;
        text-align: center;
        &:after{
          content:'';
          display: inline-block;
          width:1px;
          height:100%;
          background:#e6e6e6;;
        }
      }
      span{
        display: inline-block;
        margin-top:10px;
      }
    }
    .footer{
      background:#F3F4F9;
      padding:8px;
      text-align: center;
      color:#666;
      font-size:12px;
      letter-spacing: 1px;
    }
  }
  .itemdetail{
    margin:auto;
    background:#FFF;
    border-radius:10px;
    margin-top:5%;
    overflow: hidden;
    margin-bottom:40px;
    width:600px;
    .imgs{
      position: relative;
      img{
        width: 100%;
      }
      i.iconfont{
        cursor: pointer;
        position: absolute;
        top:10px;
        right:10px;
        font-size:30px;
        color:rgba(0,0,0,0.6);
        z-index: 2;
      }
      i.iconfont:hover{
        color:rgba(0,0,0,0.9);
      }
    }
    .box{
      padding:30px;
      h3{
        font-weight: bold;
        color:#333;
        font-size:20px;
        margin:0px;
        margin-bottom:10px;
        letter-spacing: 1px;
      }
      .leabel{
        margin-bottom:15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
      div.lis{
        margin:0px;
        margin-bottom:5px;
        line-height:1.5em;
        font-weight: initial;
        letter-spacing: 1px;
        .col-xs-6{
          margin-bottom:10px;
          img{
            width:16px;
            float:left;
          }
          div{
            display: block;
            margin-left:25px;
            margin-top:-2px;
          }
        }
        i{
          color:#F0AD4E;
        }
      }
      .leabel span{
        letter-spacing: 2px;
        &:after{
          content:'/';
        }
        &:last-child{
          &:after{
            content:'';
          }
        }
      }
      a.btn{
        background-color:#EA4335;
        color:#FFF;
        border:0px;
        letter-spacing: 3px;
        @keyframes rotate{
          0%{
            transform: rotateZ(0deg);/*从0度开始*/
          }
          100%{
            transform: rotateZ(360deg);/*360度结束*/
          }
        }
        i.xuanzhuan{
            display: inline-block;
            font-size:12px;
            animation: rotate 2s linear infinite;
        }
      }
    }
    @media (max-width: 767px) {
      .box{
        padding:15px;
        h3{
          font-weight:initial;
          line-height: 1.5em;
          color:#333;
          font-size:15px;
        }
        .leabel{
          margin-bottom:15px;
        }
        div.lis{
          margin:0px;
          font-size:12px;
          margin-bottom:5px;
          line-height:1.5em;
          font-weight: initial;
          letter-spacing: 1px;
          .col-xs-6{
            margin-bottom:10px;
            img{
              width:16px;
              float:left;
            }
            div{
              display: block;
              margin-left:25px;
              margin-top:0px;
            }
          }
          i{
            color:#F0AD4E;
          }
        }
      }
    }
  }


  .loading{
    margin:auto;
    /*background:#FFF;*/
    margin-top:5%;
    margin-bottom:40px;
    width:100px;
    display: flex;
    justify-content: center;
  }

  @media (max-width: 767px) {
    .download{
      margin-top:20%;
      width:95%;
      .top{
        img{
          height: 120px;
        }
        .cent{
          width:50px;
        }
      }
    }
    .yinshua{
      margin-top:20%;
      width:95%;
      .top{
        img{
          height: 120px;
        }
        .cent{
          width:50px;
        }
      }
    }
    .make{
      margin-top:20%;
      width:95%;
      .top{
        img{
          height: 120px;
        }
        .cent{
          width:50px;
        }
      }
      
    }
    .itemdetail{
      margin-top:20%;
      width:95%;
    }
  }

  .animated1 {
      animation-duration: 0.1s;
      animation-fill-mode: both;
  }
  .animated2 {
      animation-duration: 0.2s;
      animation-fill-mode: both;
  }
  .animated3 {
      animation-duration: 0.3s;
      animation-fill-mode: both;
  }


</style>



// WEBPACK FOOTER //
// src/components/common/download/index.vue